import { useEffect, useRef } from 'react';

/**
 *
 * User : 이연우
 * Date : 2023.06.13
 * @ file : script/useDidMountEffect.js
 * @ Desc : useEffect 첫 렌더링 시 실행막기 
 */
const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useDidMountEffect;